import { useEffect, useState } from 'preact/hooks';
import { ErrorBox } from '../components/ui.tsx';
import { api } from '../lib/api.ts';

export function Acceso() {
  const [mode, setMode] = useState<'password' | 'link'>('password');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: Event) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (mode === 'password') {
        await api('POST', '/api/auth/login', { email, password });
        location.assign('/presidencia');
      } else {
        setSent((await api<{ message: string }>('POST', '/api/auth/magic-link', { email })).message);
      }
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div class="app narrow">
      <header class="top"><div><h1>Entrar</h1><p class="sub">Presidencia, secretaría y administración de la organización.</p></div></header>
      <form class="panel" onSubmit={submit}>
        <ErrorBox error={error} />
        {sent && <p class="notice" role="status">{sent}</p>}
        <div class="field">
          <label for="email">Email</label>
          <input id="email" type="email" autoComplete="username" value={email} onInput={(e) => setEmail(e.currentTarget.value)} required />
        </div>
        {mode === 'password' && (
          <div class="field">
            <label for="password">Contraseña</label>
            <input id="password" type="password" autoComplete="current-password" value={password} onInput={(e) => setPassword(e.currentTarget.value)} required />
          </div>
        )}
        <button class="btn primary" type="submit" disabled={busy}>
          {mode === 'password' ? (busy ? 'Entrando…' : 'Entrar') : (busy ? 'Enviando…' : 'Enviarme un enlace')}
        </button>
        <button type="button" class="btn link" onClick={() => { setMode(mode === 'password' ? 'link' : 'password'); setSent(null); setError(null); }}>
          {mode === 'password' ? 'Prefiero recibir un enlace por correo' : 'Prefiero usar mi contraseña'}
        </button>
      </form>
    </div>
  );
}

/** Destino del magic link: canjea el token por POST y lo quita de la URL. */
export function Entrar() {
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const token = new URLSearchParams(location.search).get('token') ?? '';
    history.replaceState(null, '', '/entrar');
    api('POST', '/api/auth/magic-link/consume', { token })
      .then(() => location.replace('/presidencia'))
      .catch((e: Error) => setError(e.message));
  }, []);
  return (
    <div class="app narrow">
      <div class="panel">
        {error ? <><ErrorBox error={error} /><a class="btn" href="/acceso">Pedir otro enlace</a></> : <p>Entrando…</p>}
      </div>
    </div>
  );
}
